export enum MFAModeEnum {
  Email = 'Email',
  SMS = 'SMS',
}

export interface UserMFA {
  enable: boolean;
  userId: string;
  modes: MFAModeEnum[];
}
